module.exports = __webpack_public_path__ + "img/work.2debade7.jpeg";